import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';

@Pipe({
  name: 'categoryBillable'
})
export class CategoryBillablePipe implements PipeTransform {
  public transform(category: Category): number {
    let totalHoursCost = 0;
    let total = 0;

    for (const estimateLine of category.estimateLines) {
      for (const classificationLine of estimateLine.classificationLines) {
        totalHoursCost += classificationLine.hours * classificationLine.rateCost;
        total = totalHoursCost * (1 + estimateLine.departmentEstimate.estimate.rate);
      }
    }

    return total;
  }
}
